{
  "cc-flywheel-activation.confluence-first-ever-view-notification-email.email.body.cta1.button.link-name": [
    {
      "type": 0,
      "value": "View more insights"
    }
  ],
  "cc-flywheel-activation.confluence-first-ever-view-notification-email.email.body.cta2-template-link-name": [
    {
      "type": 0,
      "value": "Try template"
    }
  ],
  "cc-flywheel-activation.confluence-first-ever-view-notification-email.email.body.cta2-template-name": [
    {
      "type": 0,
      "value": "Meeting Notes"
    }
  ],
  "cc-flywheel-activation.confluence-first-ever-view-notification-email.email.body.first-line-with-content-type": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "contentType"
    },
    {
      "type": 0,
      "value": " just got its first view"
    }
  ],
  "cc-flywheel-activation.confluence-first-ever-view-notification-email.email.body.second-line.line1": [
    {
      "type": 0,
      "value": "Your work is already helping your team stay on the same page."
    }
  ],
  "cc-flywheel-activation.confluence-first-ever-view-notification-email.email.body.second-line.line2": [
    {
      "type": 0,
      "value": "To keep the collaboration momentum going, many teams use Confluence for meeting agendas and notes to make shared decisions easy to reference."
    }
  ],
  "cc-flywheel-activation.confluence-first-ever-view-notification-email.email.unsubscribe.text.no-translate": [
    {
      "type": 0,
      "value": "Unsubscribe"
    }
  ],
  "cc-flywheel-activation.confluence-first-ever-view-notification-email.message-template-template.email.body.img.alt.no-translate": [
    {
      "type": 0,
      "value": "Image depicting a "
    },
    {
      "type": 1,
      "value": "contentType"
    }
  ],
  "cc-flywheel-activation.confluence-first-ever-view-notification-email.message-template.email.content-type.blog-post": [
    {
      "type": 0,
      "value": "blog post"
    }
  ],
  "cc-flywheel-activation.confluence-first-ever-view-notification-email.message-template.email.content-type.live-page": [
    {
      "type": 0,
      "value": "live page"
    }
  ],
  "cc-flywheel-activation.confluence-first-ever-view-notification-email.message-template.email.content-type.page": [
    {
      "type": 0,
      "value": "page"
    }
  ],
  "cc-flywheel-activation.confluence-first-ever-view-notification-email.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "contentType"
    },
    {
      "type": 0,
      "value": " just got your first view ever!"
    }
  ],
  "cc-flywheel-activation.confluence-personalized-use-case-expansion-email.message-template-template.email.body.img.alt.no-translate": [
    {
      "type": 0,
      "value": "Description of image"
    }
  ],
  "cc-flywheel-activation.confluence-personalized-use-case-expansion-email.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "Post Office Test Message from "
    },
    {
      "type": 1,
      "value": "env"
    }
  ],
  "cc-flywheel-activation.confluence-personalized-use-case-expansion-email.test-message.email.body.hello.no-translate": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "cc-flywheel-activation.confluence-personalized-use-case-expansion-email.test-message.email.body.no-translate": [
    {
      "type": 0,
      "value": "This is a test message from the "
    },
    {
      "type": 1,
      "value": "env"
    },
    {
      "type": 0,
      "value": " environment."
    }
  ],
  "cc-flywheel-activation.confluence-personalized-use-case-expansion-email.test-message.email.body.regards.no-translate": [
    {
      "type": 0,
      "value": "Team Post Office"
    }
  ],
  "cc-flywheel-activation.confluence-personalized-use-case-expansion-email.test-message.email.body.signoff.no-translate": [
    {
      "type": 0,
      "value": "Regards,"
    }
  ],
  "cc-flywheel-activation.confluence-personalized-use-case-expansion-email.test-message.email.unsubscribe.text.no-translate": [
    {
      "type": 0,
      "value": "Unsubscribe"
    }
  ],
  "cc-flywheel-activation.confluence-personalized-use-case-expansion.email.button-text": [
    {
      "type": 0,
      "value": "Create meeting notes"
    }
  ],
  "cc-flywheel-activation.confluence-personalized-use-case-expansion.email.description": [
    {
      "type": 0,
      "value": "Share goals, set context, and save time with a meeting notes template."
    }
  ],
  "cc-flywheel-activation.confluence-personalized-use-case-expansion.email.footer.copyright": [
    {
      "type": 0,
      "value": "Copyright "
    },
    {
      "type": 1,
      "value": "year"
    },
    {
      "type": 0,
      "value": " Atlassian Pty Ltd. All rights reserved."
    }
  ],
  "cc-flywheel-activation.confluence-personalized-use-case-expansion.email.footer.office-address": [
    {
      "type": 0,
      "value": "341 George Street, Sydney, NSW, 2000, Australia"
    }
  ],
  "cc-flywheel-activation.confluence-personalized-use-case-expansion.email.header": [
    {
      "type": 0,
      "value": "Keep meetings aligned and actionable"
    }
  ],
  "cc-flywheel-activation.confluence-personalized-use-case-expansion.email.header-image.alt-text": [
    {
      "type": 0,
      "value": "Atlassian Confluence logo"
    }
  ],
  "cc-flywheel-activation.confluence-personalized-use-case-expansion.email.main-image.alt-text": [
    {
      "type": 0,
      "value": "Meeting notes illustration showing document with highlighted content"
    }
  ],
  "cc-flywheel-activation.confluence-personalized-use-case-expansion.email.meeting-notes-image.alt-text": [
    {
      "type": 0,
      "value": "Meeting notes"
    }
  ],
  "cc-flywheel-activation.confluence-personalized-use-case-expansion.email.meeting-notes-text": [
    {
      "type": 0,
      "value": "Meeting notes"
    }
  ],
  "cc-flywheel-activation.confluence-personalized-use-case-expansion.email.unsubscribe-link-text": [
    {
      "type": 0,
      "value": "If you no longer wish to receive these emails, please update your preferences or unsubscribe "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "here"
        }
      ],
      "type": 8,
      "value": "a"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "cc-flywheel-activation.confluence-personalized-use-case-expansion.message-template.email.subject": [
    {
      "type": 0,
      "value": "Save time with a Confluence meeting notes template"
    }
  ],
  "cc-flywheel-activation.confluence-reactivate-inactive-link-paste-in-jira-email.body.hello": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "cc-flywheel-activation.confluence-reactivate-inactive-link-paste-in-jira-email.body.part1": [
    {
      "type": 0,
      "value": "Your teammates are using Confluence to share project context, capture decisions, and more in "
    },
    {
      "type": 1,
      "value": "projectName"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "cc-flywheel-activation.confluence-reactivate-inactive-link-paste-in-jira-email.body.part2": [
    {
      "type": 0,
      "value": "Here's what they've recently linked to your Jira project:"
    }
  ],
  "cc-flywheel-activation.confluence-reactivate-inactive-link-paste-in-jira-email.message-template.email.subject": [
    {
      "type": 0,
      "value": "Your team in "
    },
    {
      "type": 1,
      "value": "projectName"
    },
    {
      "type": 0,
      "value": " is using Confluence for project docs--see what they’ve added"
    }
  ],
  "cc-flywheel-activation.confluence-reactivate-inactive-link-paste-in-jira-email.message-template.footer.text": [
    {
      "type": 0,
      "value": "This message was sent to you by Atlassian Cloud"
    }
  ],
  "cc-flywheel-activation.confluence-reactivate-inactive-link-paste-in-jira-email.test-message.email.body.button-cta": [
    {
      "type": 0,
      "value": "Open Confluence"
    }
  ],
  "cc-flywheel-activation.confluence-reactivate-inactive-link-paste-in-jira-email.test-message.email.body.signoff": [
    {
      "type": 0,
      "value": "See what else is happening across your company:"
    }
  ],
  "confluence-reminder.cta.button": [
    {
      "type": 0,
      "value": "Accept invite"
    }
  ],
  "confluence-reminder.customer-logos.alt": [
    {
      "type": 0,
      "value": "Customer logos including Twilio, NASA, Illumina, Docker, and Morningstar"
    }
  ],
  "confluence-reminder.email.subject": [
    {
      "type": 0,
      "value": "Reminder: "
    },
    {
      "type": 1,
      "value": "inviterName"
    },
    {
      "type": 0,
      "value": " invited you to collaborate in Confluence"
    }
  ],
  "confluence-reminder.footer.address": [
    {
      "type": 0,
      "value": "341 George Street, Sydney, NSW, 2000, Australia"
    }
  ],
  "confluence-reminder.footer.copyright": [
    {
      "type": 0,
      "value": "Copyright "
    },
    {
      "type": 1,
      "value": "year"
    },
    {
      "type": 0,
      "value": " Atlassian Pty Ltd. All rights reserved."
    }
  ],
  "confluence-reminder.inviter.avatar.alt": [
    {
      "type": 0,
      "value": "Profile photo of "
    },
    {
      "type": 1,
      "value": "inviterName"
    }
  ],
  "confluence-reminder.main.heading": [
    {
      "type": 1,
      "value": "inviterName"
    },
    {
      "type": 0,
      "value": " invited you to join Confluence"
    }
  ],
  "confluence-reminder.product.description": [
    {
      "type": 0,
      "value": "Plan projects, run meetings, and brainstorm ideas with your team—all in one place."
    }
  ],
  "confluence-reminder.redacted.heading": [
    {
      "type": 0,
      "value": "Reminder: Join your team in Confluence"
    }
  ],
  "confluence-reminder.redacted.subject": [
    {
      "type": 0,
      "value": "Reminder: Join your team in Confluence"
    }
  ],
  "confluence-reminder.social-proof.text": [
    {
      "type": 1,
      "value": "numberOfCustomers"
    },
    {
      "type": 0,
      "value": " customers use "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " to move work forward"
    }
  ],
  "confluence.fastAndSnappy.survey.question": [
    {
      "type": 0,
      "value": "To what extent do you agree or disagree with the following statement?"
    }
  ],
  "confluence.fastAndSnappy.survey.score-subtext.neutral": [
    {
      "type": 0,
      "value": "Neutral"
    }
  ],
  "confluence.fastAndSnappy.survey.score-subtext.strongly-agree": [
    {
      "type": 0,
      "value": "Strongly agree"
    }
  ],
  "confluence.fastAndSnappy.survey.score-subtext.strongly-disagree": [
    {
      "type": 0,
      "value": "Strongly disagree"
    }
  ],
  "confluence.fastAndSnappy.survey.statement": [
    {
      "type": 0,
      "value": "Confluence feels fast and snappy."
    }
  ],
  "confluence.lovability.survey.new-question": [
    {
      "type": 0,
      "value": "How much do you love using Confluence?"
    }
  ],
  "confluence.lovability.survey.question": [
    {
      "type": 0,
      "value": "To what extent do you agree or disagree with the following statement?"
    }
  ],
  "confluence.lovability.survey.score-subtext.neutral": [
    {
      "type": 0,
      "value": "Neutral"
    }
  ],
  "confluence.lovability.survey.score-subtext.not-at-all": [
    {
      "type": 0,
      "value": "Not at all"
    }
  ],
  "confluence.lovability.survey.score-subtext.very-much": [
    {
      "type": 0,
      "value": "Very much"
    }
  ],
  "confluence.lovability.survey.statement": [
    {
      "type": 0,
      "value": "Confluence is a product I love using."
    }
  ],
  "post-office-team.confluence-reactivate-inactive-link-paste-in-jira-email.atlassian-logo": [
    {
      "type": 0,
      "value": "Atlassian Logo"
    }
  ]
}